import { render } from "./inquiryForm.vue?vue&type=template&id=03d9ba21&scoped=true"
import script from "./inquiryForm.vue?vue&type=script&lang=js"
export * from "./inquiryForm.vue?vue&type=script&lang=js"

import "./inquiryForm.vue?vue&type=style&index=0&id=03d9ba21&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d9ba21"]])

export default __exports__